import { render, staticRenderFns } from "./CourseStatistics.vue?vue&type=template&id=5d1684bb&scoped=true&"
import script from "./CourseStatistics.vue?vue&type=script&lang=js&"
export * from "./CourseStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=5d1684bb&scoped=true&lang=css&"
import style1 from "./CourseStatistics.vue?vue&type=style&index=1&id=5d1684bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1684bb",
  null
  
)

export default component.exports